import React, { useMemo, useState } from 'react';

// try a few image file names so your public/People folder "just works"
function candidatesFromName(name) {
  const safe = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  const parts = (name || '').trim().split(/\s+/);
  const first = parts[0] || '';
  const last  = parts[parts.length - 1] || '';
  const slug  = safe(name || '');
  const guesses = [
    `/People/${slug}.jpg`, `/People/${slug}.png`, `/People/${slug}.jpeg`,
    `/People/${safe(first)}-${safe(last)}.jpg`,
    `/People/${safe(first)}.jpg`, `/People/${safe(last)}.jpg`,
  ];
  return [...new Set(guesses)];
}

export default function TeamCardOrganizers({ member, frameless = false, hideSocial = false }) {
  // Build the image list once per name/image change (fixes exhaustive-deps)
  const list = useMemo(() => {
    const given = member.image ? [member.image] : [];
    const guess = candidatesFromName(member.name);
    return [...given, ...guess];
  }, [member.image, member.name]);

  const [idx, setIdx] = useState(0);
  const src = list[idx]
    ? (list[idx].startsWith('/') ? process.env.PUBLIC_URL + list[idx] : list[idx])
    : null;
  const onError = () => setIdx((i) => (i + 1 < list.length ? i + 1 : i));

  return (
    <article className={frameless ? 'card card--frameless' : 'card'}>
      <div className="avatar-wrap">
        {src ? (
          <img className="avatar" src={src} alt={member.name} onError={onError} />
        ) : (
          <div className="avatar avatar-fallback">
            {(member.name || '').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()}
          </div>
        )}
      </div>

      <h3 className="name name-font">{member.name}</h3>
      <p className="role">{member.role}</p>

      {!hideSocial && (
        <div className="socials">
          {member.linkedin && (
            <a
              className="social-btn"
              href={member.linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label={`${member.name} on LinkedIn`}
              title="LinkedIn"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.5 8h4v16h-4zM8 8h3.8v2.2h.05C12.38 9.2 13.67 8 15.6 8 19.61 8 20.35 10.64 20.35 14.08V24h-4v-7.1c0-1.69-.03-3.87-2.36-3.87-2.36 0-2.73 1.84-2.73 3.75V24H8V8z" />
              </svg>
            </a>
          )}
        </div>
      )}
    </article>
  );
}
